import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DialPadButtonBase } from 'features/dial-pad/styles';
import { DialPadEventBus } from 'features/dial-pad/services';

interface DialPadClearButtonProps {
  dialedNumber: string;
  clearAllAndClose: (text: string) => void;
}

export const DialPadCloseButton: FC<DialPadClearButtonProps> = ({
  dialedNumber,
  clearAllAndClose,
}) => {
  const { t } = useTranslation('translation');

  const handleClearDialPad = () => {
    clearAllAndClose(dialedNumber);
    DialPadEventBus.clearDtmf$.next();
  };

  return (
    <CloseButton
      onClick={handleClearDialPad}
      data-testid='dialpad-close-button'
      $flex={2}
    >
      {t('dialPad.closeDialPad')}
    </CloseButton>
  );
};

const CloseButton = DialPadButtonBase;
